import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { Inverter1Tab4Api } from '../../../../../../../api/Api';
import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../../../assets/img/logos/logo 2.png';
import RefreshIcon from '@mui/icons-material/Refresh';
import { AuthenticationContext } from '../../../../../../../context/AuthenticationContext';
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../../api/AxiosApi'
import ExportExcel from '../../../../../../../components/exportExcel/ExportExcel1';
import ExportPdf from '../../../../../../../components/exportPdf/ExportPdf';

// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

function Tab4Inverter1Log({ ID, TabTitle, Dt1, Dt2 }) {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const { palette, spacing, shape: { borderRadius } } = useTheme()

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(8);


    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const credentials = {
        LID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        pass_key: "xyz",
        DT1: StartDate,
        DT2: EndDate,
        MTR_CODE: ID,
    };
    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        // Generate credentials dynamically using current values
        try {
            const res = await Inverter1Tab4Api(credentials);
            if (res?.DC_AC_KW_DATA && Array.isArray(res.DC_AC_KW_DATA)) {
                setLogData(res.DC_AC_KW_DATA);
            } else {
                setLogData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    // Re-fetch data whenever StartDate, EndDate, or ID changes
    useEffect(() => {
        fetchLogData();
    }, [ID, StartDate, EndDate]);

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Define keys to exclude (you can also define keys to include instead)
    const excludeKeys = [""]; // Replace "key1", "key2" with actual keys you don't want to export

    // Filter logData
    const filteredLogData = logData.map((item) => {
        const filteredItem = {};
        Object.keys(item).forEach((key) => {
            if (!excludeKeys.includes(key)) {
                filteredItem[key] = item[key]; // Include keys not in excludeKeys
            }
        });
        return filteredItem;
    });

    // Get table headers from filteredLogData
    const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

    // Export to Excel
    // Export to Excel
    //    const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, `MIS_2`);
    //     // XLSX.writeFile(wb, `${TabTitle} To ${EndDate.replace(" ", "T")}  DC Vs AC Power.xlsx`);

    //     const fileName = `${TabTitle}To  ${EndDate.replace(/\s+/g, 'T')}DC Vs AC Power.xlsx`;
    //             XLSX.writeFile(wb, fileName);
    // };

    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            filteredLogData,
            StartDate,
            EndDate,
            `${TabTitle}_ DC Vs AC Power`,
            LoggedInUserInfo
        );
    };

    // Export to PDF
    // const exportToPDF = () => {
    //     const doc = new jsPDF();

    //     // Add Logo (x, y, width, height)
    //     const imgWidth = 30;  // Adjust width
    //     const imgHeight = 20; // Adjust height
    //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    //     doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

    //     // Add Title or Text Below the Logo
    //     const title = `${TabTitle} To  DC Vs AC Power ${EndDate.replace(" ", "T")}`;
    //     doc.setFontSize(12);  // Adjust font size
    //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

    //     // Adjust Y position for the table to start below the text
    //     let startY = 50;  // Push table further down below text

    //     doc.autoTable({
    //         head: [tableHeaders],
    //         body: logData.map((item) => tableHeaders.map((key) => item[key])),
    //         startY: startY,  // Start table below the logo and text
    //         theme: "grid",
    //     });

    //     doc.save(`${TabTitle} To  DC Vs AC Power`);
    // };

    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            currentData,
            StartDate,
            EndDate,
            `${TabTitle}_DC Vs AC Power`,
            LoggedInUserInfo,
            logo,
            tableHeaders

        );
    };


    useEffect(() => {
        if (Dt1 && Dt2) {
            setStartDate(Dt1);
            setEndDate(Dt2);
        }
    }, [Dt1, Dt2]);



    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    console.log("LogTabTitle", Dt1, Dt2)



    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>
                <div style={{}}>
                    {/* Controls */}
                    <div className="row">
                        <div className="col-md-12">
                            <div style={containerStyle} className="head">
                                <p style={responsiveHeaderStyle}>DC Vs AC Power</p>
                                <div style={responsiveControlsStyle}>


                                    <button onClick={exportToExcel} style={exportButtonStyle}>
                                        Excel
                                    </button>
                                    <button onClick={exportToPDF} style={exportButtonStyle2}>
                                        PDF
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Table */}
                    <div className="table-responsive">
                        <table className="table table-hover table-bordered">
                            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                <tr>
                                    <th style={tableHeading}> Sn. </th>
                                    <th style={tableHeading}> Date </th>
                                    <th style={tableHeading}>DC_Power_KW</th>
                                    <th style={tableHeading}> AC_POWER_KW</th>



                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : currentData.length > 0 ? (
                                    currentData.map((item, rowIndex) => (
                                        <tr key={rowIndex}>

                                            <td className="text-center align-middle" style={tableBody}>
                                                {item.Sn ?? ""}
                                            </td>

                                            <td className="text-center align-middle" style={tableBody}>
                                                {item.DATETIME ?? ""}
                                            </td>

                                            <td className="text-center align-middle" style={tableBody}>
                                                {item.DC_Power_KW ?? ""}
                                            </td>
                                            <td className="text-center align-middle" style={tableBody}>
                                                {item.AC_POWER_KW ?? ""}
                                            </td>


                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={paginationButtonStyle}
                        >
                            Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => {
                            const isActive = currentPage === index + 1;
                            return (
                                <button
                                    key={index}
                                    onClick={() => handlePageChange(index + 1)}
                                    style={{
                                        ...paginationButtonStyle,
                                        backgroundColor: isActive ? "#356E35" : "white",
                                        color: isActive ? "#fff" : "#356E35",
                                    }}
                                >
                                    {index + 1}
                                </button>
                            );
                        })}

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={paginationButtonStyle}
                        >
                            Next
                        </button>
                    </div>
                </div>

            </Box>
        </>
    );
}

export default Tab4Inverter1Log;


/* Styles */

const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    // border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
    display: "flex",
    flexWrap: "wrap"
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "2px 2px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    // marginLeft: "5px",
    // fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "0 5px",
    cursor: "pointer",
    fontSize: "14px",
};


const tableHeading = {
    color: "rgb(53, 110, 53)",
    padding: "12px 10px",
    fontSize: "14px",
    whiteSpace: "nowrap",
}

const tableBody = {
    padding: "5px",
    whiteSpace: "nowrap",
}